export const language: any = {
  add_by_image: "फोटो के रूप में जोड़ें",
  add_image_by_camera: "कैमरे से तस्वीर लें",
  add_image_by_gallery: "फोटो चुनें",
  loading: "हम एक स्वादिष्ट रेसिपी तैयार कर रहे हैं।\nकृपया एक क्षण प्रतीक्षा करें।",
  retry: "पुनः प्रयास करें",
  cancel: "रद्द करें",
  yes: "हाँ",
  no: "नहीं",
  goToIngredient: "सामग्री का विश्लेषण",
  goToRecipe: "डिश का विश्लेषण",
  recipe: {
    title: "एआई रेसिपी",
    analysis_results: "विश्लेषण परिणाम",
    ingredients: {
      title: "सामग्री (1 सर्विंग)",
      view_more: "अधिक सामग्री देखें",
      view_less: "छिपाएँ",
    },
    how_to_cook: "पकाने की विधि",
    go_to_detail: "एआई रेसिपी देखें",
    description: "रेसिपी परिचय",
    calories: "कैलोरी",
    time: "पकाने का समय",
    ingredient: "मुख्य सामग्री",
    spice: "मसाले",
    tip: "सुझाव",
  },
  ingredient: {
    title: "फोटो विश्लेषण",
    analysis_results: "फोटो विश्लेषण से निम्नलिखित सामग्री मिली है।",
    add_to_cart: "कार्ट में जोड़ें",
    add_to_my_ingredients: "सामग्री में जोड़ें",
  },
  msg: {
    not_ingredients: `यह एक शानदार फोटो है,\nलेकिन यहाँ केवल सामग्री की बात होती है!\nअगली बार स्वादिष्ट सामग्री को कैप्चर करें—\nखाने की दुनिया के रहस्य आपका इंतजार कर रहे हैं!\nक्या आप एआई शेफ पर जाना चाहते हैं?`,
    not_recipes: `यह कोई पकवान नहीं है!\nहम केवल तैयार किए गए व्यंजनों की तस्वीरों का विश्लेषण कर सकते हैं।\nकृपया पके हुए व्यंजन की फोटो अपलोड करें।\nक्या आप सामग्री का विश्लेषण करना चाहते हैं?`,
    not_found: "नहीं मिला",
    unknow: `मुझे नहीं लगता कि यह किसी व्यंजन या सामग्री की फोटो है।\nकृपया अपने व्यंजन या सामग्री की फोटो अपलोड करें\nताकि हम बेहतर मदद कर सकें!`,
    upload_fail: `अस्थायी त्रुटि के कारण अपलोड विफल हो गया।\nकृपया थोड़ी देर में पुनः प्रयास करें।`,
    error: `ओह! फोटो विश्लेषण सफल नहीं हुआ।\nकृपया एक और फोटो चुनें,\nया क्या हम कोई स्पष्ट फोटो आज़माएँ?`,
    bothType: `इस फोटो में सामग्री और व्यंजन दोनों हैं!\nकृपया चुनें कि आप फोटो में क्या विश्लेषण करना चाहते हैं।`,
  },
}
